import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <img 
              src="/assets/avex-logo.png" 
              alt="Avex Enterprises" 
              className="h-12 mb-4 brightness-200"
            />
            <p className="text-[#888888] text-sm">
              Premium lighting solutions for modern spaces across Nepal.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-[#888888] hover:text-[#BFA15F] transition-colors">Home</Link></li>
              <li><Link to="/products" className="text-[#888888] hover:text-[#BFA15F] transition-colors">Products</Link></li>
              <li><Link to="/about" className="text-[#888888] hover:text-[#BFA15F] transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-[#888888] hover:text-[#BFA15F] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-heading text-lg mb-4">Categories</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products?category=chandeliers" className="text-[#888888] hover:text-[#BFA15F] transition-colors">Chandeliers</Link></li>
              <li><Link to="/products?category=wall-lights" className="text-[#888888] hover:text-[#BFA15F] transition-colors">Wall Lights</Link></li>
              <li><Link to="/products?category=outdoor-lighting" className="text-[#888888] hover:text-[#BFA15F] transition-colors">Outdoor Lighting</Link></li>
              <li><Link to="/products?category=commercial-lighting" className="text-[#888888] hover:text-[#BFA15F] transition-colors">Commercial Lighting</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 mt-1 text-[#BFA15F]" />
                <span className="text-[#888888]">+977-9816315999</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 mt-1 text-[#BFA15F]" />
                <span className="text-[#888888]">info@avexenterprises.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-1 text-[#BFA15F]" />
                <span className="text-[#888888]">Biratnagar, Nepal</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#4A4A4A] mt-8 pt-8 text-center text-sm text-[#888888]">
          <p>&copy; {new Date().getFullYear()} Avex Enterprises. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;